import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { sectionSortMethod_LabelMap, sectionSortMethods } from '@app/advisor-ui-shared';
const mandatoryProps_SectionSortMethod = {
    adapter: SimpleListAdapter([...sectionSortMethods], item => _jsx(_Fragment, { children: sectionSortMethod_LabelMap[item.item] })),
    caret: DropDown_DefaultCaret,
    placeholder: 'Select Section Render Method',
};
export const DropDown_SectionSortMethod = TS_DropDown.prepare(mandatoryProps_SectionSortMethod);
//# sourceMappingURL=ui-components.js.map